(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tipset/assets/javascripts/views/match.js') >= 0) return;  svs.modules.push('/modules/tipset/assets/javascripts/views/match.js'); 
(function(Backbone, _, svs) {
  'use strict';

  var insetHandleOffset = 22,
    minimumSelectablePercent = 10,
    noReduceButtonWidth = 36,
    paddingBetweenButtons = 0,
    halfPaddingBetweenButtons = paddingBetweenButtons / 2;

  svs.tipset.views.Match = Backbone.Marionette.View.extend({
    tagName: 'li',

    className: 'match list-group-item js-clickable clickable-list-item-tipset',

    events: {
      'click .js-row-button': 'markBetButton',
      'touchstart .js-outcomes': 'touchStartBetButton',
      click: 'matchClicked',

      'touchstart .reduce-handle-container': 'touchStartHandle',
      'touchmove .reduce-handle-container': 'touchMoveHandle',

      'click .reduce-handle-container': 'clickHandle',
      'mousedown .reduce-handle-container': 'mouseDownHandle'
    },

    ui: {
      outcomesContainer: '.js-outcomes',
      homeButton: '.tipsen-bet-button-position.home',
      drawButton: '.tipsen-bet-button-position.draw',
      awayButton: '.tipsen-bet-button-position.away',
      firstHandle: '.reduce-handle-container.handle-left',
      secondHandle: '.reduce-handle-container.handle-right',
      percentageHome: '.tipsen-bet-button-position.home .reduce-percentage',
      percentageDraw: '.tipsen-bet-button-position.draw .reduce-percentage',
      percentageAway: '.tipsen-bet-button-position.away .reduce-percentage'
    },

    modelEvents: {
      'change changeStatistics': 'render'
    },

    template: function(data) {
      if (svs.tipset.models.play.get('isReduceMode')) {
        return svs.tipset.templates.match_reduce(data);
      }
      return svs.tipset.templates.match(data);
    },

    touchStartHandle: function(e) {
      e.preventDefault();

      this.currentMoveHandle = e.currentTarget;
    },

    touchMoveHandle: function(e) {
      e.preventDefault();
    },

    clickHandle: function(e) {
      e.preventDefault();
    },

    mouseDownHandle: function(e) {
      e.preventDefault();

      this.currentMoveHandle = e.currentTarget;
    },

    templateContext: function() {
      var showHandleBetween1AndX =
        this.model.get('marks').home.isSet &&
        this.model.get('marks').draw.isSet ||
        this.model.get('marks').home.isSet &&
        this.model.get('marks').away.isSet,
        showHandleBetweenXAnd2 =
          this.model.get('marks').draw.isSet &&
          this.model.get('marks').away.isSet ||
          this.model.get('marks').home.isSet &&
          this.model.get('marks').away.isSet,
        insetHandle = false;

      if (
        this.model.get('marks').home.isSet &&
        !this.model.get('marks').draw.isSet &&
        this.model.get('marks').away.isSet
      ) {
        insetHandle = true;
      }

      return {
        showHandleBetween1AndX: showHandleBetween1AndX,
        showHandleBetweenXAnd2: showHandleBetweenXAnd2,
        insetHandle: insetHandle,
        hasAnyMarks: this.model.hasMarks()
      };
    },

    initialize: function() {
      this.fixLayout = this.fixLayout.bind(this);
      this.handleMoveEvent = this.handleMoveEvent.bind(this);
      this.onResize = this.onResize.bind(this);
      this.onTouchMove = this.onTouchMove.bind(this);
      this.onTouchEnd = this.onTouchEnd.bind(this);
      this.onMouseUp = this.onMouseUp.bind(this);
      this.onMouseMove = this.onMouseMove.bind(this);

      this.listenTo(
        this.model,
        'buttonBet_' + this.model.get('eventNumber'),
        this.forceAdjustButtons
      );
      this.listenTo(svs.tipset.models.play, 'change', this.render);
      this.listenTo(
        svs.tipset.collections.matchlist,
        'buttonBet',
        this.fixLayout
      );

      if (svs.core.detect.formfactor.mobile()) {
        svs.tipset.productBase.on('tabChanged', this.fixLayout);
      }

      $(window).on('resize', this.onResize);
      $(window).on('touchmove', this.onTouchMove);
      $(window).on('touchend', this.onTouchEnd);
      $(window).on('mouseup', this.onMouseUp);
      $(window).on('mousemove', this.onMouseMove);
    },

    onDestroy: function() {
      if (svs.core.detect.formfactor.mobile()) {
        svs.tipset.productBase.off('tabChanged', this.fixLayout);
      }
      $(window).off('resize', this.onResize);
      $(window).off('touchmove', this.onResize);
      $(window).off('touchend', this.onTouchEnd);
      $(window).off('mouseup', this.onMouseUp);
      $(window).off('mousemove', this.onMouseMove);
    },

    onResize: function() {
      this.setPixelWidthContainer();
      this.forceAdjustButtons();
    },

    onTouchMove: function(e) {
      if (!this.currentMoveHandle) {
        return;
      }

      var firstTouch;

      if (e.changedTouches.length > 0) {
        firstTouch = e.changedTouches[0];
      }

      if (!firstTouch) {
        return;
      }

      this.handleMoveEvent(firstTouch.clientX);
    },

    onTouchEnd: function() {
      this.currentMoveHandle = undefined;
    },

    onMouseUp: function(e) {
      var self = this;
      e.preventDefault();
      e.stopPropagation();
      setTimeout(function() {
        self.currentMoveHandle = undefined;
      });
    },

    onMouseMove: function(e) {
      this.handleMoveEvent(e.clientX);
    },

    fixLayout: function() {
      this.setPixelWidthContainer();
      this.forceAdjustButtons();
    },

    handleMoveEvent: function(position) {
      if (!this.currentMoveHandle) {
        return;
      }

      var $handle = $(this.currentMoveHandle),
        $otherHandle =
          $handle.get(0) === this.ui.firstHandle.get(0)
            ? this.ui.secondHandle
            : this.ui.firstHandle,
        oldHandlePosition = parseInt($handle.css('left'), 10),
        oldOtherHandlePosition = parseInt($otherHandle.css('left'), 10),
        handleHalfWidth = $handle.find('.reduce-handle').outerWidth() / 2,
        cursorPosition = position,
        differenceBetweenHandles = oldHandlePosition - oldOtherHandlePosition,
        newPosition = cursorPosition - handleHalfWidth,
        newPositionOther =
          cursorPosition - handleHalfWidth - differenceBetweenHandles;

      $handle.css('left', newPosition + 'px');

      if (!this.model.isButtonSet(2)) {
        $otherHandle.css('left', newPositionOther + 'px');
      }

      var buttonWidths = this.getButtonWidths();

      this.adjustOutcomeButtons($handle);
      this.calculateWeightsFromOutcomeButtons();
      this.updatePercentageText();

      var weights = this.model.get('weights'),
        actualPercent = {
          home: Math.round(weights[0]),
          draw: Math.round(weights[1]),
          away: Math.round(weights[2])
        };

      if (
        actualPercent.home < minimumSelectablePercent &&
        this.model.isButtonSet(1) ||
        actualPercent.draw < minimumSelectablePercent &&
        this.model.isButtonSet(2) ||
        actualPercent.away < minimumSelectablePercent &&
        this.model.isButtonSet(4)
      ) {
        this.forceSetButtonWidths(buttonWidths);
      }
    },

    setPixelWidthContainer: function() {
      if (!svs.tipset.models.play.get('isReduceMode')) {
        return;
      }
      this.ui.outcomesContainer.width('100%');
      this.ui.outcomesContainer.width(
        parseInt(this.ui.outcomesContainer.width(), 10) + 'px'
      );
    },

    onAttach: function() {
      var self = this;
      setTimeout(function() {
        self.setPixelWidthContainer();
        self.forceAdjustButtons();
      }, 100);
    },

    onDomRefresh: function() {
      this.setPixelWidthContainer();
    },

    getButtonWidths: function() {
      return {
        home: this.ui.homeButton.width(),
        draw: this.ui.drawButton.width(),
        away: this.ui.awayButton.width()
      };
    },

    forceSetButtonWidths: function(buttonWidths) {
      this.ui.homeButton.width(buttonWidths.home);
      this.ui.drawButton.width(buttonWidths.draw);
      this.ui.awayButton.width(buttonWidths.away);

      this.adjustHandlesFromButtons();
      this.calculateWeightsFromOutcomeButtons();
      this.updatePercentageText();
    },

    adjustHandlesFromButtons: function() {
      var reduceLeftHandleHalfWidth =
        this.ui.firstHandle.find('.reduce-handle').outerWidth() / 2,
        reduceRightHandleHalfWidth =
          this.ui.secondHandle.find('.reduce-handle').outerWidth() / 2,
        homeButtonRight =
          this.ui.homeButton.offset().left + this.ui.homeButton.outerWidth(), 
        drawButtonRight =
          this.ui.drawButton.offset().left + this.ui.drawButton.outerWidth(), 
        leftHandlePosition =
          homeButtonRight -
          reduceLeftHandleHalfWidth -
          halfPaddingBetweenButtons,
        rightHandlePosition =
          drawButtonRight -
          reduceRightHandleHalfWidth -
          halfPaddingBetweenButtons -
          3;

      if (!this.model.isButtonSet(2)) {
        leftHandlePosition -= insetHandleOffset;
        rightHandlePosition += insetHandleOffset;
      }

      this.ui.firstHandle.css('left', parseInt(leftHandlePosition, 10) + 'px');
      this.ui.secondHandle.css(
        'left',
        parseInt(rightHandlePosition, 10) + 'px'
      );
    },

    forceAdjustButtons: function() {
      if (!svs.tipset.models.play.get('isReduceMode')) {
        return;
      }

      var weights = this.model.get('weights'),
        containerWidth =
          typeof this.ui.outcomesContainer === 'object'
            ? this.ui.outcomesContainer.outerWidth()
            : 0,
        buttonIndexMapping = [
          this.ui.homeButton,
          this.ui.drawButton,
          this.ui.awayButton
        ],
        isAnyMarkSelected = false;

      if (containerWidth === 0) {
        return;
      }

      if (!weights) {
        return;
      }

      weights.forEach(function(weight) {
        if (weight > 0) {
          isAnyMarkSelected = true;
        }
      });

      weights.forEach(function(weight, index) {
        if (!isAnyMarkSelected) {
          return;
        }

        if (weight === 0) {
          containerWidth -= noReduceButtonWidth;
          if (index === 0 || index === 1) {
            containerWidth -= paddingBetweenButtons;
          }
        }
      });

      for (var i = 0; i < weights.length; ++i) {
        var buttonWidth;
        if (!isAnyMarkSelected) {
          buttonWidth = Math.round(containerWidth / weights.length);
          buttonIndexMapping[i].css('width', buttonWidth + 'px');
        } else {
          if (weights[i] > 0) {
            buttonWidth = Math.round(weights[i] / 100 * containerWidth);
            buttonIndexMapping[i].css('width', buttonWidth + 'px');
          } else {
            buttonIndexMapping[i].css('width', 'auto');
          }
        }
      }

      this.adjustHandlesFromButtons();
    },

    adjustOutcomeButtons: function($handle) {
      var buttonWidths = this.calculateOutcomeButtonWidths($handle);

      if (this.model.isButtonSet(1)) {
        this.ui.homeButton.css('width', buttonWidths.home + 'px');
      }

      if (this.model.isButtonSet(2)) {
        this.ui.drawButton.css('width', buttonWidths.draw + 'px');
      }

      if (this.model.isButtonSet(4)) {
        this.ui.awayButton.css('width', buttonWidths.away + 'px');
      }
    },

    calculateOutcomeButtonWidths: function($handle) {
      var leftHandle = this.ui.firstHandle.find('.reduce-handle'),
        rightHandle = this.ui.secondHandle.find('.reduce-handle'),
        leftHandlePosition = leftHandle.offset().left,
        rightHandlePosition = rightHandle.offset().left,
        offset,
        homeWidth = this.ui.homeButton.outerWidth(),
        drawWidth = this.ui.drawButton.outerWidth(),
        awayWidth = this.ui.awayButton.outerWidth();

      if ($handle.get(0) === this.ui.firstHandle.get(0)) {
        var limitRight = this.ui.awayButton.offset().left;

        offset =
          leftHandlePosition +
          leftHandle.outerWidth() / 2 +
          halfPaddingBetweenButtons;
        if (!this.model.isButtonSet(2)) {
          offset += insetHandleOffset;
        }
        homeWidth = offset - this.ui.homeButton.offset().left;

        offset =
          leftHandlePosition +
          leftHandle.outerWidth() / 2 +
          halfPaddingBetweenButtons;
        if (!this.model.isButtonSet(2)) {
          offset += insetHandleOffset;
        }
        drawWidth = limitRight - offset;

        offset =
          rightHandlePosition +
          rightHandle.outerWidth() / 2 +
          halfPaddingBetweenButtons;
        awayWidth =
          this.ui.outcomesContainer.offset().left +
          this.ui.outcomesContainer.outerWidth() -
          offset;

        if (!this.model.isButtonSet(2)) {
          awayWidth += insetHandleOffset;
        }
      } else {
        offset =
          leftHandlePosition +
          leftHandle.outerWidth() / 2 +
          halfPaddingBetweenButtons;
        if (!this.model.isButtonSet(2)) {
          offset += insetHandleOffset;
        }
        homeWidth = offset - this.ui.homeButton.offset().left;

        offset = this.ui.drawButton.offset().left;
        drawWidth =
          rightHandlePosition +
          rightHandle.outerWidth() / 2 +
          halfPaddingBetweenButtons -
          offset;

        if (!this.model.isButtonSet(2)) {
          drawWidth -= insetHandleOffset;
        }

        offset =
          rightHandlePosition +
          rightHandle.outerWidth() / 2 +
          halfPaddingBetweenButtons;
        awayWidth =
          this.ui.outcomesContainer.offset().left +
          this.ui.outcomesContainer.outerWidth() -
          offset;

        if (!this.model.isButtonSet(2)) {
          awayWidth += insetHandleOffset;
        }
      }

      return {
        home: homeWidth <= 0 ? 0 : homeWidth,
        draw: drawWidth <= 0 ? 0 : drawWidth,
        away: awayWidth <= 0 ? 0 : awayWidth
      };
    },

    calculateWeightsFromOutcomeButtons: function() {
      var isHomeSet = this.model.isButtonSet(1),
        isDrawSet = this.model.isButtonSet(2),
        isAwaySet = this.model.isButtonSet(4),
        homeWidth = isHomeSet ? this.ui.homeButton.width() : 0,
        drawWidth = isDrawSet ? this.ui.drawButton.width() : 0,
        awayWidth = isAwaySet ? this.ui.awayButton.width() : 0;

      this.model.updateWeights(homeWidth, drawWidth, awayWidth);
    },

    updatePercentageText: function() {
      var weights = this.model.get('weights');
      this.ui.percentageHome.text(
        100 - Math.round(weights[1]) - Math.round(weights[2]) + '%'
      );
      this.ui.percentageDraw.text(Math.round(weights[1]) + '%');
      this.ui.percentageAway.text(Math.round(weights[2]) + '%');
    },

    touchStartBetButton: function(ev) {
      if (svs.tipset.models.play.get('isReduceMode')) {
        return;
      }
      var target = $(ev.currentTarget),
        minimumDeltaX = 5,
        startButton,
        startButtonRowButton,
        startButtonSelected = false,
        startButtonSet = false,
        startX = ev.touches[0].clientX,
        deltaX,
        onMove = function(e) {
          var touch = e.touches[0],
            clientX = touch.clientX,
            clientY = touch.clientY,
            rowButton,
            currentEl;

          deltaX = Math.abs(clientX - startX);

          if (deltaX > minimumDeltaX) {
            if (
              !startButtonSet &&
              startButtonRowButton &&
              target.has(startButtonRowButton).length > 0 &&
              !startButtonRowButton.hasClass('js-row-button-touch-set') &&
              startButtonRowButton
                .find('.btn-bet')
                .hasClass('btn-bet-selected') === startButtonSelected
            ) {
              startButtonSet = true;
              startButtonRowButton.addClass('js-row-button-touch-set').click();
            }

            currentEl = $(document.elementFromPoint(clientX, clientY));

            if (currentEl.hasClass('js-row-button')) {
              rowButton = currentEl;
            } else if (currentEl.hasClass('btn-bet')) {
              rowButton = currentEl.parent('.js-row-button');
            }

            if (
              rowButton &&
              target.has(rowButton).length > 0 &&
              !rowButton.hasClass('js-row-button-touch-set') &&
              rowButton.find('.btn-bet').hasClass('btn-bet-selected') ===
              startButtonSelected
            ) {
              rowButton.addClass('js-row-button-touch-set').click();
            }
          }

          e.preventDefault();
        },
        onEnd = function(e) {
          target.find('.js-row-button').removeClass('js-row-button-touch-set');
          target.off('touchmove', onMove);
          target.off('touchend', onEnd);

          if (deltaX > minimumDeltaX) {
            e.preventDefault();
            e.stopPropagation();
          }
        };

      if ($(ev.target).hasClass('js-row-button')) {
        startButton = $(ev.target).find('.btn-bet');
      } else if ($(ev.target).hasClass('btn-bet')) {
        startButton = $(ev.target);
      }

      startButtonRowButton = startButton.parent('.js-row-button');

      if (startButton && startButton.hasClass('btn-bet-selected')) {
        startButtonSelected = true;
      }

      target.on('touchmove', onMove);
      target.on('touchend', onEnd);
    },

    markBetButton: function(ev) {
      var item = $(ev.currentTarget),
        mark = item.data('mark'),
        isMG = mark === svs.tipset.constants.MG_VALUE,
        btnBet = item.find('.btn-bet'),
        percentage = item.find('.reduce-percentage');

      if (!btnBet.is(':disabled')) {
        btnBet.toggleClass('btn-bet-selected');
        btnBet[0].offsetHeight; 

        if (isMG) {
          this.model.setMg();
        } else {
          this.model.setButtonBet(mark, {
            triggerChange: false
          });
          this.forceAdjustButtons();
          this.updatePercentageText();
        }

        var currentMark = _.findWhere(this.model.get('marks'), {
            boardData: mark
          }),
          mg = this.model.get('marks').mg,
          mgButton = btnBet
            .parents('.js-outcomes')
            .find(
              '.js-row-button[data-mark="' +
              svs.tipset.constants.MG_VALUE +
              '"] .btn-bet'
            );

        if (currentMark.isSet) {
          btnBet.addClass('btn-bet-selected');

          if (isMG) {
            btnBet
              .parents('.js-outcomes')
              .find('.btn-bet-label-system')
              .remove();
          } else if (currentMark.isU) {
            if (btnBet.find('.btn-bet-label-system').length === 0) {
              btnBet
                .parents('.js-outcomes')
                .find('.btn-bet-label-system')
                .remove();
              btnBet.append($('<span class="btn-bet-label-system">U</span>'));
            } else {
              btnBet.find('.btn-bet-label-system').remove();
            }
          }
        } else {
          btnBet.removeClass('btn-bet-selected');
          btnBet.find('.btn-bet-label-system').remove();
          percentage.addClass('hidden-percentage');
        }

        if (mg.isDisabled) {
          mgButton.attr('disabled', 'disabled');
          mgButton.removeClass('btn-bet-selected');
        } else {
          mgButton.removeAttr('disabled');
        }
      }
    },

    matchClicked: function(ev) {
      if (this.currentMoveHandle) {
        return;
      }
      if (this.model.get('participantType') !== 'Player') {
        var isCurrentMatch =
          !svs.core.detect.formfactor.mobile() &&
          this.model.get('isCurrentMatch'),
          is1X2Button =
            ev.target.type == 'button' ||
            ev.target.children.length > 0 &&
            ev.target.children[0].type == 'button';

        ev.preventDefault();
        if (isCurrentMatch || is1X2Button) {
          return false;
        } else if (!svs.core.detect.formfactor.mobile()) {
          if (svs.tipset.views.matchview.bigNavOpen) {
            this.model.setCurrentMatch(true);
          } else {
            this.model.setCurrentMatch(true);
            svs.tipset.views.matchview.showBigNav();
          }
        } else {
          this.model.setCurrentMatch(true);
        }
      }
    },

    onBeforeRender: function() {
      if (
        !this.model.get('match') ||
        this.model.get('participantType') === 'Player'
      ) {
        this.$el.removeClass('js-clickable');
        this.$el.removeClass('js-clickable-delayed-click');
        this.$el.removeClass('clickable-list-group-item-tipset');
        this.$el.addClass('disabled');
      }
      if (svs.core.detect.formfactor.mobile()) {
        this.el.classList.add('js-clickable-delayed-click');
      } else {
        if (this.model.get('isCurrentMatch')) {
          this.el.classList.add('current-match');
        } else {
          this.el.classList.remove('current-match');
        }
      }
    },

    onRender: function() {
      this.forceAdjustButtons();
      this.updatePercentageText();
    }
  });
})(Backbone, _, svs);

 })(window);